"use strict";
/* 依赖的模块，在这里统一引入，方便打包优化 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scrollbar = exports.Slider = exports.HtmlTooltip = exports.ContinuousLegend = exports.CategoryLegend = exports.CircleGrid = exports.LineGrid = exports.CircleAxis = exports.LineAxis = exports.Annotation = exports.Crosshair = exports.Component = exports.GroupComponent = exports.HtmlComponent = exports.Scale = exports.registerScale = exports.getScale = exports.Coordinate = exports.registerCoordinate = exports.getCoordinate = exports.Color = exports.Attribute = exports.getAttribute = exports.Adjust = exports.getAdjust = exports.registerAdjust = exports.AbstractShape = exports.AbstractGroup = exports.Event = void 0;
// G
var g_base_1 = require("@antv/g-base");
Object.defineProperty(exports, "Event", { enumerable: true, get: function () { return g_base_1.Event; } });
Object.defineProperty(exports, "AbstractGroup", { enumerable: true, get: function () { return g_base_1.AbstractGroup; } });
Object.defineProperty(exports, "AbstractShape", { enumerable: true, get: function () { return g_base_1.AbstractShape; } });
// adjust
var adjust_1 = require("@antv/adjust");
Object.defineProperty(exports, "registerAdjust", { enumerable: true, get: function () { return adjust_1.registerAdjust; } });
Object.defineProperty(exports, "getAdjust", { enumerable: true, get: function () { return adjust_1.getAdjust; } });
Object.defineProperty(exports, "Adjust", { enumerable: true, get: function () { return adjust_1.Adjust; } });
// attr
var attr_1 = require("@antv/attr");
Object.defineProperty(exports, "getAttribute", { enumerable: true, get: function () { return attr_1.getAttribute; } });
Object.defineProperty(exports, "Attribute", { enumerable: true, get: function () { return attr_1.Attribute; } });
var attr_2 = require("@antv/attr");
Object.defineProperty(exports, "Color", { enumerable: true, get: function () { return attr_2.Color; } });
// coordinate
var coord_1 = require("@antv/coord");
Object.defineProperty(exports, "getCoordinate", { enumerable: true, get: function () { return coord_1.getCoordinate; } });
Object.defineProperty(exports, "registerCoordinate", { enumerable: true, get: function () { return coord_1.registerCoordinate; } });
Object.defineProperty(exports, "Coordinate", { enumerable: true, get: function () { return coord_1.Coordinate; } });
// scale
var scale_1 = require("@antv/scale");
Object.defineProperty(exports, "getScale", { enumerable: true, get: function () { return scale_1.getScale; } });
Object.defineProperty(exports, "registerScale", { enumerable: true, get: function () { return scale_1.registerScale; } });
Object.defineProperty(exports, "Scale", { enumerable: true, get: function () { return scale_1.Scale; } });
// component
var component_1 = require("@antv/component");
Object.defineProperty(exports, "Annotation", { enumerable: true, get: function () { return component_1.Annotation; } });
Object.defineProperty(exports, "Component", { enumerable: true, get: function () { return component_1.Component; } });
Object.defineProperty(exports, "Crosshair", { enumerable: true, get: function () { return component_1.Crosshair; } });
Object.defineProperty(exports, "GroupComponent", { enumerable: true, get: function () { return component_1.GroupComponent; } });
Object.defineProperty(exports, "HtmlComponent", { enumerable: true, get: function () { return component_1.HtmlComponent; } });
Object.defineProperty(exports, "Slider", { enumerable: true, get: function () { return component_1.Slider; } });
Object.defineProperty(exports, "Scrollbar", { enumerable: true, get: function () { return component_1.Scrollbar; } });
// axis
var LineAxis = component_1.Axis.Line, CircleAxis = component_1.Axis.Circle;
exports.LineAxis = LineAxis;
exports.CircleAxis = CircleAxis;
// grid
var LineGrid = component_1.Grid.Line, CircleGrid = component_1.Grid.Circle;
exports.LineGrid = LineGrid;
exports.CircleGrid = CircleGrid;
// legend
var CategoryLegend = component_1.Legend.Category, ContinuousLegend = component_1.Legend.Continuous;
exports.CategoryLegend = CategoryLegend;
exports.ContinuousLegend = ContinuousLegend;
// Tooltip
var HtmlTooltip = component_1.Tooltip.Html;
exports.HtmlTooltip = HtmlTooltip;
//# sourceMappingURL=dependents.js.map